import axiosInstance from "@/config/axiosInstance";

/**
 * Upload image for blog post
 * @param {File} file - Image file to upload
 * @param {Function} onUploadProgress - Optional callback for upload progress
 * @returns {Promise<{url: string}>}
 */
export const uploadImage = async (file, onUploadProgress) => {
  const formData = new FormData();
  formData.append("featured_image", file);

  const response = await axiosInstance.post("/api/upload/image", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
    onUploadProgress: onUploadProgress
      ? (progressEvent) => {
          const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
          onUploadProgress(percentCompleted);
        }
      : undefined,
  });

  return response.data;
};

/**
 * Get full URL for uploaded image
 * @param {string} path - Relative path returned from upload
 * @returns {string} - Full URL
 */
export const getImageUrl = (path) => {
  if (!path) return "";
  if (path.startsWith("http")) return path;
  return `${axiosInstance.defaults.baseURL}${path}`;
};
